export default function InvoiceFilters({ 
  fromDate, 
  setFromDate, 
  toDate, 
  setToDate, 
  onSearch, 
  onClear,
  tipoFiltro,
  onTipoFiltro
}) {
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('-');
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('es-SV', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };

  const tipos = [
    { value: 'todas',    label: '🗂️ Todas' },
    { value: '01',       label: '📄 Consumidor Final' },
    { value: '03',       label: '🧾 Crédito Fiscal' },
    { value: 'anuladas', label: '🚫 Anuladas' },
  ];

  return (
    <div>
      {/* Botones FUERA del box */}
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '16px' }}>
        {tipos.map((t) => (
          <button
            key={t.value}
            onClick={() => onTipoFiltro(t.value)}
            style={{
              padding: '6px 16px',
              borderRadius: '20px',
              border: '2px solid',
              borderColor: tipoFiltro === t.value ? '#667eea' : '#e2e8f0',
              background: tipoFiltro === t.value ? '#667eea' : 'white',
              color: tipoFiltro === t.value ? 'white' : '#4a5568',
              fontWeight: 600,
              fontSize: '13px',
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* Box de fechas */}
      <div className="invoice-filters">
        <div className="filters-row">
          <div className="form-group">
            <label className="form-label">📅 Fecha Inicio</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label className="form-label">📅 Fecha Fin</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>

          <div className="filters-actions">
            <button className="btn btn-primary" onClick={onSearch}>
              🔍 Buscar
            </button>
            <button className="btn btn-secondary" onClick={onClear}>
              🔄 Limpiar
            </button>
          </div>
        </div>

        {fromDate && toDate && (
          <div className="alert alert-info">
            <span>
              📊 Buscando facturas desde <strong>{formatDate(fromDate)}</strong> hasta{" "}
              <strong>{formatDate(toDate)}</strong>
            </span>
          </div>
        )}
      </div>
    </div>
  );
}